<div class="u2b-order-assignee-fields" [formGroup]="parentFormGroup">
    <mat-form-field *ngIf="showAssigneeTypeField"
                    class="u2b-order-assignee-fields__type"
                    [appearance]="appearance">
        <mat-label>{{ 'widgets.docksite.orderDetailV2.taskPositions.assigneeType' | translate }}</mat-label>
        <mat-select formControlName="assigneeType"
                    data-test="FS-Auftrag-Zustaendigkeit-Typ"
                    [disabled]="disabled">
            <mat-option [value]="null">
                {{ 'widgets.docksite.orderDetailV2.taskPositions.assigneeNone' | translate }}
            </mat-option>
            <mat-option *ngFor="let type of visibleAssigneeTypes" [value]="type">
                {{ 'widgets.docksite.orderDetailV2.taskPositions.assigneeTypes.' + type | translate }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="parentFormGroup.get('assigneeType')?.value === OrderTaskPositionAssigneeType.Employee"
                    class="u2b-order-assignee-fields__target"
                    [appearance]="appearance">
        <mat-label>{{ 'widgets.docksite.orderDetailV2.taskPositions.assigneeTypes.employee' | translate }}</mat-label>
        <mat-select formControlName="bcm_employees_id"
                    data-test="FS-Auftrag-Zustaendigkeit-Mitarbeiter"
                    [disabled]="disabled">
            <mat-option [value]="null">–</mat-option>
            <mat-option *ngFor="let employee of employees" [value]="employee.id">
                {{ employeeLabel(employee) }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="parentFormGroup.get('assigneeType')?.value === OrderTaskPositionAssigneeType.Department"
                    class="u2b-order-assignee-fields__target"
                    [appearance]="appearance">
        <mat-label>{{ 'widgets.docksite.orderDetailV2.taskPositions.assigneeTypes.department' | translate }}</mat-label>
        <mat-select formControlName="bcm_departments_id"
                    data-test="FS-Auftrag-Zustaendigkeit-Abteilung"
                    [disabled]="disabled">
            <mat-option [value]="null">–</mat-option>
            <mat-option *ngFor="let department of departments" [value]="department.id">
                {{ department.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
